import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import type { HelpdeskTaskTypePageInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-page.dto';
import type { HelpdeskTaskTypeRegistryQueryInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-registry-query.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskTaskTypeService extends BaseService {
  protected baseUrl = '/helpdesk/task-type';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public findPage(queryParams?: HelpdeskTaskTypeRegistryQueryInterface): Observable<HelpdeskTaskTypePageInterface> {
    return this.http.get<HelpdeskTaskTypePageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public restoreOne(id: number): Observable<HelpdeskTaskTypeFindInterface> {
    return this.http.post<HelpdeskTaskTypeFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistoryForAll(options?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/history`, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }

  public getHistoryForOne(id: number, options?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }
}
